export default __webpack_public_path__ + "static/media/pdf-icon.a433db30.svg";